/* eslint-disable react/prop-types */
import React, {useContext, useEffect, useState} from 'react';
import {HTTP_STATUS_OK} from '../../../smartpak/httpstatus';
import {BridleContext} from '../BridleContextProvider';

const AttributeOptionsWithSwatch = ({colors}) => {
    const {styles, setProducts, options, setOptions, defaultOptions} = useContext(BridleContext);
    const [selectedColor, setSelectedColor] = useState();

    useEffect(() => {
        if (options.Color.ColorId) {
            const match = colors.filter(color => {
                return color.attributeValueId === options.Color.ColorId;
            });
            setSelectedColor(match[0].attributeValueId);
        }
    }, []);

    function handleColorSelection(ColorId, ColorName) {
        let currentOptions = {...options};
        if (!!options.Color.ColorId && options.Color.ColorId !== ColorId) {
            currentOptions = defaultOptions;
        }

        setOptions({
            ...currentOptions,
            Color: {ColorId: ColorId, ColorName: ColorName}
        });

        setSelectedColor(ColorId);

        setSelectedColor(ColorId);
    }

    useEffect(() => {
        if (!!styles.id && !!options.Color.ColorId) {
            fetch(`/api/bundlebuilder/getsteps?styleId=${styles.id}&attributeValueId=${options.Color.ColorId}`)
                .then(response => response.json())
                .then(results => {
                    if (results.status === HTTP_STATUS_OK) {
                        setProducts(results.content);
                    }
                });
        }
    }, [options.Color.ColorId]);

    return (
        <ul className="button-selector input-group is-narrow" data-cols="2" data-type="swatch">
            {colors &&
                colors.map((attr, index) => {
                    return (
                        <li key={index}>
                            <input
                                type="radio"
                                id={attr.attributeValueId}
                                name="select-color"
                                checked={attr.attributeValueId === selectedColor}
                                onChange={() => handleColorSelection(attr.attributeValueId, attr.attributeValueName)}
                            />
                            <label className="radio" htmlFor={attr.attributeValueId} tabIndex="0">
                                <span className={'button-swatch ' + attr.attributeValueName}></span>
                                {attr.attributeValueName}
                            </label>
                        </li>
                    );
                })}
        </ul>
    );
};

export default AttributeOptionsWithSwatch;
